export default __webpack_public_path__ + "static/client-6-d5e5f9cb816b78d939b84edbc44f7e33.jpg";